// extracted by mini-css-extract-plugin
export default {"character-settings":"character-settings__JgFDc","characterSettings":"character-settings__JgFDc","row":"row__zLuUf","label":"label__T8d04","control":"control__C6kFJ"};